import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Label } from '@/components/ui/label';
import { usePurchaseOrderPdfPreview } from '@/services/apis/mutations/purchase-orders/use-purchase-order-pdf-preview';

type PurchaseOrderSendAttachmentPreviewProps = {
  isSending: boolean;
  purchaseOrderId: string;
};

export function PurchaseOrderSendAttachmentPreview({
  isSending,
  purchaseOrderId,
}: PurchaseOrderSendAttachmentPreviewProps) {
  const { t } = useTranslation('purchaseOrder');
  const { mutate: previewPdf, isPending: isLoadingPdf } =
    usePurchaseOrderPdfPreview();

  const handlePreviewPdf = () => {
    if (isLoadingPdf || isSending) {
      return;
    }
    previewPdf(purchaseOrderId, {
      onSuccess: (blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank', 'noopener,noreferrer');
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      },
      onError: () => {
        toast.error(t('error', { ns: 'common' }), {
          description: t('sendPoModalPdfPreviewError'),
        });
      },
    });
  };

  return (
    <div className='flex flex-col gap-2'>
      <Label>{t('sendPoModalAttachment')}</Label>
      <button
        className='flex w-fit items-center gap-2 text-primary transition-opacity hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-50'
        disabled={isLoadingPdf || isSending}
        onClick={handlePreviewPdf}
        type='button'
      >
        <span className='text-sm'>{t('sendPoModalAttachmentFile')}</span>
        <Download className='size-4' />
      </button>
    </div>
  );
}
